<template>
  <div class="tech-wrapper" v-if="wizard.path === 'hosting'">
    <div v-for="opt of wizard.opzioniTecnologieHosting" :key="opt" class="tech-item">
      <pf-checkbox :label="opt" name="tecnologie[]" :value="opt" :model-value="modelValue.includes(opt)" @change="change" />
    </div>
  </div>

  <pf-flex class="tech-wrapper" v-else-if="wizard.path === 'cloud'">
    <pf-flex-item v-for="cat of Object.keys(wizard.opzioniTecnologieCloud)" :key="cat" class="tech-item">
      <pf-title h="6">{{ cat }}</pf-title>

      <pf-checkbox
        v-for="opt of wizard.opzioniTecnologieCloud[cat]"
        :key="opt"
        :label="opt"
        name="tecnologie[]"
        :value="opt"
        :model-value="modelValue.includes(opt)"
        @change="change"
      />
    </pf-flex-item>
  </pf-flex>
</template>

<style lang="scss" scoped>
.tech-wrapper {
  column-width: 250px;

  .tech-item {
    margin: 1px 0;
    min-width: 250px;
  }
}
</style>

<script setup lang="ts">
import { useWizardQuestion } from '@/wizard';

defineOptions({
  inheritAttrs: false,
});

defineProps<{
  modelValue: string[];
}>();

const { wizard } = useWizardQuestion();

function change(e: Event) {
  if (e.target instanceof HTMLInputElement) {
    if (e.target.checked) {
      wizard.tecnologie.push(e.target.value);
    } else {
      wizard.tecnologie.splice(wizard.tecnologie.indexOf(e.target.value), 1);
    }
  }
}
</script>
